import { useTranslation } from 'react-i18next';
import './Footer.css';

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <p className="site-footer__copy">
        {t('footer.copyright', { year })}
      </p>
    </footer>
  );
}
